export default __webpack_public_path__ + "static/Saira-Medium-2c78b14f12c1d3bc3bed1fbc85e3c7b7.woff2";